export  class DataLayerService {

  constructor() {
    window.dataLayer = window.dataLayer || [];
  }

  /**
   * Add object to dataLayer
   * @param {{}} object
   */
  addDataLayerItem(object) {
    if (object) {
      window.dataLayer.push(object);
    }
  }

  /**
   * Add payload for event
   * @param {GoogleUaEvent} googleUAEvent - Payload object
   * @param {boolean} replaceIfExists - If true, all events with same name will be deleted from the dataLayer object
   */
  triggerUaEvent(googleUAEvent, replaceIfExists = false) {
    if (replaceIfExists) {
      let itemRemoved = true
      while (itemRemoved) {
        let index = window.dataLayer.findIndex(item => item.event === googleUAEvent.eventName);
        if (index > -1) {
          window.dataLayer.splice(index, 1);
        } else {
          itemRemoved = false
        }
      }
    }

    window.dataLayer.push(this.buildDataLayerEvent(googleUAEvent));
  }

  /**
   * Build value of object in dataLayer format
   * @param googleUAEvent
   * @returns {{[p: string]: {action: *, label: *, category: *, value: *}, event: (string|string|*)}}
   */
  buildDataLayerEvent(googleUAEvent) {
    return {
      'event': googleUAEvent.eventName,
      'uaEventData': {
        'category': googleUAEvent.category,
        'action': googleUAEvent.action,
        'label': googleUAEvent.label,
        'value': googleUAEvent.value
      }
    }
  }
}